module.exports = __webpack_public_path__ + "img/format_underlined.d81a68b1.svg";